import React, { useId,useState } from 'react';
import OurStorySec from './ourstorysections/OurStorySec';
import Section1 from './homesections/Section1';
import Section2 from './homesections/Section2';
import Ourstory from "../assets/images/Ourstory.svg";
import { Col, Row } from 'react-bootstrap';
import indiciWeb from '../assets/images/our-story_1.webp'
import { Image } from 'antd';
import { Spin } from 'antd';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import LazyLoad from 'react-lazyload';
import styled from "styled-components";
import { Link } from 'react-router-dom';
interface Ourstoryprops {
}
export const OurStory: React.FunctionComponent<Ourstoryprops> = (props) => {
    // const pageId1 = useId()
const TextContainer = styled.div`
text-align: center;
`;
const Title = styled.span`
  display: block;
  /* color: #fff;
  line-height: 90px; */
`; 
const [loading, setLoading]=useState(true)
setTimeout(() => {
  setLoading(false); // Hide loader after 8 seconds
}, 3000);
    return (
        <React.Fragment>
           {/* <div className='relative-container'>
           <LazyLoadImage src={indiciWeb} className='w-100'
              placeholderSrc={indiciWeb} alt="Image Alt"/>
           
            <div className='banner-text'>
            <TextContainer>
                  <Title className="main-heading"> {`Our`}<br/>
                  {`Story`}</Title>
                </TextContainer>
            </div>
        </div>  */}
         {loading ? <Spin spinning={loading} style={{fontSize:48}}  fullscreen /> : 
          <Section1 background={indiciWeb} title1={`Our`}
          title2={`Story`} />}
            <OurStorySec>
                <Row className='shpbgrow py-5 my-5  align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={3} className="text-center mt-sm-3">
                        <Image width={200} src={Ourstory} preview={false} />
                    </Col>
                    <Col sm={12} md={9} className="text-center text-md-start mb-sm-3 my-margin">
                        <h2 className='myindici-heading mb-3'>Our Story</h2>
                        <p className='text-break storypara mb-3'>
                            As a vendor of frontier healthcare technologies, we have been developing and 
                            implementing digital solutions designed specifically 
                            for the 
                            New Zealand market for over 10
                             years. Our flagship Electronic Health Record platform indici 
                             first went live in 2017 
                             and is now in use all over New Zealand, 
                             supporting an ever-growing family of 
                             over 250 medical practices and over two million
                              active patient records.<br/></p><p className='text-break storypara mb-3'>
                        myindici is an integral member of the indici family, developed around
                         a patient-centric design that extends the vivifying benefits of
                          modern technologies
                          directly to patients and their families.<br/>
                          </p><p className='text-break storypara mb-3'>
                        With the recent roll out of our enhanced patient portal myindici 2.0, 
                        we are consistently
                         striving to improve our offerings by anticipating and meeting the
                          needs
                          of patients and providers now and into the future.<br/>
                      </p><p className='text-break storypara mb-3'>
                            In addition to indici and myindici, we offer a wide range of expert
                             solutions that span
                             the healthcare sphere, and you can find more information about 
                             these at the below link:
                        </p>
                        {/* <Link to="https://indici.co.nz/" className='paralink'>
                        https://indici.co.nz/</Link> */}
                        <a href="https://indici.co.nz/" target="_blank" className="paralink">https://indici.co.nz/</a>
                    </Col>
                </Row >
            </OurStorySec>
        </React.Fragment>
    )
}
export default OurStory;